import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react'; // Or use an inline SVG/character '←'
import './BackButton.css';

const BackButton = ({ 
  to = -1, 
  label = "Back", 
  onClick, 
  variant = "subtle", // 'subtle' | 'pill' | 'ghost'
  classAttribute
}) => {
  const navigate = useNavigate();

  const handleBack = (e) => {
    if (onClick) {
      onClick(e);
    } else if (typeof to === 'number') {
      navigate(to);
    } else {
      navigate(to);
    }
  };

  return (
    <button 
      type="button" 
      onClick={handleBack} 
      className={`app-back-btn ${classAttribute} back-btn-${variant}`  }
      aria-label="Go Back"
    >
      <ArrowLeft size={18} className="back-btn-icon" />
      <span className="back-btn-label">{label}</span>
    </button>
  );
};

export default BackButton;